import { Minimize } from "@mui/icons-material"

export const useHtmlText = () => {

  function getRowSpan(data, r, c) {
    let i = 1
    let rowSpan = 1
    while ((r + i) < data.length && data[r + i][c] === "[^]") {
      rowSpan += 1
      i += 1
    }
    return (rowSpan > 1) ? ` rowspan="${rowSpan}"` : ""
  }

  function getColSpan(data, r, c) {
    let i = 1
    let colSpan = 1
    while ((c + i) < data[r].length && data[r][c + i] === "[<]") {
      colSpan += 1
      i += 1
    }
    return (colSpan > 1) ? ` colspan="${colSpan}"` : ""
  }

  const getHtmlText = (srcText, separator, numThead, numTfoot) => {
    // srcTextを配列に変換する
    //   ex: "1,2\n3,4\n5,6"  =>  [[1, 2], [3, 4], [5, 6]]
    const data = srcText.split(/\n/).map((row) => row.split(separator))

    // rowspan, colspan付きの配列にする
    const dataWithSpan = data.map((row, r) => {
      return row.map((cell, c) => {
        return {
          value: cell,
          rowSpan: cell === "[^]" ? "" : getRowSpan(data, r, c),
          colSpan: cell === "[<]" ? "" : getColSpan(data, r, c)
        }
      })
    })

    // thead,tfoot,tbodyの配列上の開始・終了位置（添字）計算
    const tTagPositions = []
    if (numThead) {
      tTagPositions.push({ tag: "<thead>", type: "start", index: 1 - 1 })
      tTagPositions.push({ tag: "</thead>", type: "end", index: Math.min(numThead, data.length) - 1 })
    }
    if (numTfoot && numThead < data.length) {
      tTagPositions.push({ tag: "<tfoot>", type: "start", index: Math.max(data.length - numTfoot + 1, numThead + 1) - 1 })
      tTagPositions.push({ tag: "</tfoot>", type: "end", index: data.length - 1 })
    }
    if ((numThead || numTfoot) && (data.length > numThead + numTfoot)) {
      tTagPositions.push({ tag: "<tbody>", type: "start", index: (numThead + 1) - 1 })
      tTagPositions.push({ tag: "</tbody>", type: "end", index: (data.length - numTfoot) - 1 })
    }
    console.log(tTagPositions)

    // html生成用の配列を作成
    const array = ['<table>']  // !!!TEST!!!
    dataWithSpan.forEach((row, r) => {
      const tTagStart = tTagPositions.find((obj) => obj.type === "start" && obj.index === r)
      if (tTagStart) array.push(tTagStart.tag)
      array.push("<tr>")

      row.forEach((cell, c) => {
        if (cell.value === "[<]" || cell.value === "[^]") return
        const elem = (r <= numThead - 1) ? "th" : "td"
        array.push(`<${elem}${cell.rowSpan}${cell.colSpan}>${cell.value}</${elem}>`)
      })

      array.push("</tr>")
      const tTagEnd = tTagPositions.find((obj) => obj.type === "end" && obj.index === r)
      if (tTagEnd) array.push(tTagEnd.tag)
    })
    array.push("</table>")

    return (
      array.join('\n')
        .replace(/<\/?t(head|body|foot)>/g, '  $&') // thead,tbody,tfootタグ前  半角SPACE * 2
        .replace(/<\/?tr>/g, '    $&')              // trタグ前                 半角SPACE * 4
        .replace(/<(th|td)( |>)/g, '      $&')           // th,tdタグ前              半角SPACE * 6)
    )
  }

  return getHtmlText
}
